import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';
import PageHero from '../components/PageHero';
import HighlightPhrase from '../components/HighlightPhrase';
import { SectionWrap, SectionHeader, Bullets, TitledBullets, Prose } from '../components/SectionPrimitives';

import { VIDAT_IMG } from '../lib/images';

const IMG = VIDAT_IMG.monasterio2;

const SeniorSaludable = () => {
  const { content } = useI18n();
  const s = content.senior;
  const buttons = content.buttons;
  return (
    <main data-testid="senior-page">
      <PageHero eyebrow={s.eyebrow} title={s.title} lead={s.lead} image={IMG} testId="senior-hero" />

      <SectionWrap bg="ivory" testId="senior-forwhom">
        <SectionHeader title={s.forWhomTitle} />
        <p className="text-stone-700 font-light max-w-3xl mb-6">{s.forWhomLead}</p>
        <p className="text-stone-700 font-light max-w-2xl mb-6">{s.forWhomIntro}</p>
        <Bullets items={s.forWhom} />
      </SectionWrap>

      <SectionWrap testId="senior-problem">
        <SectionHeader title={s.problemTitle} />
        <Prose paragraphs={[s.problemP1, s.problemP2, s.problemP3]} />
      </SectionWrap>

      <SectionWrap bg="ivory" testId="senior-eval">
        <SectionHeader title={s.evalTitle} />
        <p className="text-stone-700 font-light mb-8 max-w-2xl">{s.evalLead}</p>
        <TitledBullets items={s.eval} />
      </SectionWrap>

      <SectionWrap testId="senior-integration">
        <SectionHeader title={s.integrationTitle} />
        <Prose paragraphs={[s.integrationP1, s.integrationP2]} />
        <div className="mt-8"><Bullets items={s.integrationList} /></div>
      </SectionWrap>

      <SectionWrap bg="ivory" testId="senior-interpretation">
        <SectionHeader title={s.interpretationTitle} />
        <Prose paragraphs={[s.interpretationP1, s.interpretationP2]} />
        <div className="mt-8"><Bullets items={s.interpretationList} /></div>
      </SectionWrap>

      <SectionWrap testId="senior-obtain">
        <SectionHeader title={s.obtainTitle} />
        <Bullets items={s.obtain} />
      </SectionWrap>

      <HighlightPhrase eyebrow={s.modelEyebrow} dark testId="senior-highlight">
        {s.modelHighlight}
      </HighlightPhrase>

      <SectionWrap bg="ivory" testId="senior-modeloutro">
        <Prose paragraphs={[s.modelOutro]} />
      </SectionWrap>

      <SectionWrap testId="senior-rehab">
        <SectionHeader title={s.rehabTitle} />
        <Prose paragraphs={[s.rehabP1, s.rehabP2, s.rehabP3]} />
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/rehabilitacion-funcional" className="btn-secondary" data-testid="senior-cta-rehab">
            {buttons.expandRehab}
          </Link>
          <Link to="/programar-visita" className="btn-primary" data-testid="senior-cta-join">
            {buttons.joinList}
          </Link>
        </div>
      </SectionWrap>

    </main>
  );
};

export default SeniorSaludable;
